import React, { useState, useEffect } from "react";
import "./Login.css";
import { Link } from "react-router-dom";
import logo from "../../images/CMP_Logo.svg";
import left from "../../images/login_left_image.svg";
import eclipse_top from "../../images/eclipse_top.svg";
import eclipse_bottom from "../../images/eclipse_bottom.svg";
import eclipse_85 from "../../images/eclipse_85.svg";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import axios from "axios";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { useNavigate } from "react-router-dom";


const Login = () => {
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1); // Step 1: Enter email, Step 2: Enter password or create new password
  const baseAPI = process.env.REACT_APP_API_URL;
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmitEmail = async (e) => {
    e.preventDefault();
    try {
      // Check if email exists in the database
      const response = await axios.post(`${baseAPI}/customer/checkEmail`, {
        email,
      });
      if (response.data.status === "True") {
        // Email exists, check if password exists
        if (response.data.hasPassword) {
          // Password exists, proceed to next step
          setStep(2);
        } else {
          // Password doesn't exist, proceed to create new password
          setStep(3);
        }
      } else {
        // Email does not exist
        alert("Email not found in the database");
      }
    } catch (error) {
      console.error("Error checking email:", error);
      alert("Error checking email");
    }
  };


  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseAPI}customer/customerLogin`,
        { email, password }
      );

      if (response.data.status === "True") {   
        // Check if Data and access_token exist in the response
        if (response.data.Data && response.data.Data.access_token) {         
          // Save the access token to the local storage
          localStorage.setItem('accessToken', JSON.stringify(response.data.Data.access_token));
          localStorage.setItem('email', JSON.stringify(email));
          navigate("/orderlist", { state: { email } });
        } else {
          alert("Access token not found in the response.");
        }
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error submitting password");
    }
  };

  const handleCreatePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    try {
      const response = await axios.post(
        `${baseAPI}customer/createPassword`,
        { email, password: newPassword }
      );
      if (response.data.status === "True") {
        alert(
          "Password created successfully. Please login with your new password."
        );
        setStep(2);
      } else {
        alert("Failed to create password");
      }
    } catch (error) {
      console.error("Error creating password:", error);
      alert("Error creating password");
    }
  };

 

  return (
    <>
    {step === 1 && (
    <div
      style={{ overflow: "hidden" }}
      className="container-fluid d-flex justify-content-center align-items-center min-vh-100 login-main"
    >
      <div
        style={{ height: "100vh" }}
        className="row w-100 login-mobile-view-hide"
      >
        <div className="col-7 login-main-left d-flex justify-content-center align-items-center">
          <div>
            <div className="login-left-top container-fluid">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div className="left-img-container text-start px-4">
              <img className="img-fluid" src={left} />
            </div>
            <div className="login-left-circle">
              <img className="img-fluid" src={eclipse_85} />
            </div>
            <div className="w-100 text-right">
              <div className="login-left-bottom">
                <img src={eclipse_bottom} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ boxShadow: "-5px 5px 10px rgba(0, 0, 0, 0.2)" }}
          className="col-lg-5 col-md-5 col-sm-10 col-12 d-flex align-items-center justify-content-center"
        >
          <div className="w-100 login-main-right">
            <div
              style={{ padding: "0px 20px 40px 20px", position: "relative" }}
              className="login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "40%",
                  maxWidth: "247px",
                  backgroundColor: "white",
                }}
              />
              <h2 style={{ marginTop: "90px" }}>Log In</h2>
              <form className="w-100" onSubmit={handleSubmitEmail}>
                <div
                  className="form-group text-start"
                  style={{ position: "relative" }}
                >
                  <label htmlFor="customer-id">Customer ID</label>
                  <input
                    type="text"
                    className="form-control"
                    id="customer-id"
                    placeholder="Enter"
                    style={{ paddingLeft: "46px" }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <PersonOutlineIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      left: "15px",
                      fontSize: "23px",
                      color: "#6a6a6a",
                    }}
                  />
                </div>
                <div>
                  <button type="submit" className="btn btn-primary">
                    Next
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* mobile view  */}
      <div
        style={{ overflow: "hidden" }}
        className="row w-100 login-mobile-view-show"
      >
        <div className="col-12 login-main-right d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center">
            <div className="login-right-top container-fluid text-end">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div
              style={{ padding: "0px 23px 36px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Log In
              </h2>
              <form className="w-100 ">
                <div className="form-group text-start">
                  <label htmlFor="">Customer ID</label>
                  <input
                    style={{ paddingLeft: "46px" }}
                    type="text"
                    className="form-control"
                    id=""
                    placeholder="Enter"
                  />
                  <PersonOutlineIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "15px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></PersonOutlineIcon>{" "}
                </div>
                <Link to="/createPassword">
                  <button type="submit" className="btn btn-primary">
                    Next
                  </button>
                </Link>
              </form>
            </div>
          </div>
          <div className="login-right-circle">
            <img className="img-fluid" src={eclipse_85} />
          </div>
          <div className="login-right-bottom"></div>
        </div>
      </div>
    </div>
  )}


  {step === 2 && (
    <div
      style={{ overflow: "hidden" }}
      className="container-fluid d-flex justify-content-center align-items-center min-vh-100 login-main"
    >
      <div
        style={{ height: "100vh" }}
        className="row w-100 login-mobile-view-hide"
      >
        <div className="col-7 login-main-left d-flex justify-content-center align-items-center">
          <div>
            <div className="login-left-top container-fluid">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div className="left-img-container text-start px-4">
              <img className="img-fluid" src={left} />
            </div>
            <div className="login-left-circle">
              <img className="img-fluid" src={eclipse_85} />
            </div>
            <div className="w-100 text-right">
              <div className="login-left-bottom">
                <img src={eclipse_bottom} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ boxShadow: "-5px 5px 10px rgba(0, 0, 0, 0.2)" }}
          className="col-lg-5 col-md-5 col-sm-10 col-12 d-flex align-items-center justify-content-center"
        >
          <div className="w-100 login-main-right">
            <div
              style={{ padding: "0px 20px 40px 20px", position: "relative" }}
              className="login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "40%",
                  maxWidth: "247px",
                  backgroundColor: "white",
                }}
              />
              <h2 style={{ marginTop: "90px" }}>Log In</h2>
              <form className="w-100" onSubmit={handleSubmitPassword}>
                <div
                  className="form-group text-start"
                  style={{ position: "relative" }}
                >
                  <label htmlFor="customer-id">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter"
                    style={{ paddingLeft: "46px" }}
                    value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  />
                  <PersonOutlineIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      left: "15px",
                      fontSize: "23px",
                      color: "#6a6a6a",
                    }}
                  />
                </div>
                <div >
                  <button type="submit" className="btn btn-primary">
                    Next
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* mobile view  */}
      <div
        style={{ overflow: "hidden" }}
        className="row w-100 login-mobile-view-show"
      >
        <div className="col-12 login-main-right d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center">
            <div className="login-right-top container-fluid text-end">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div
              style={{ padding: "0px 23px 36px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Log In
              </h2>
              <form className="w-100 ">
                <div className="form-group text-start">
                  <label htmlFor="">Customer ID</label>
                  <input
                    style={{ paddingLeft: "46px" }}
                    type="text"
                    className="form-control"
                    id=""
                    placeholder="Enter"
                  />
                  <PersonOutlineIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "15px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></PersonOutlineIcon>{" "}
                </div>
                <Link to="/createPassword">
                  <button type="submit" className="btn btn-primary">
                    Next
                  </button>
                </Link>
              </form>
            </div>
          </div>
          <div className="login-right-circle">
            <img className="img-fluid" src={eclipse_85} />
          </div>
          <div className="login-right-bottom"></div>
        </div>
      </div>
    </div>
  )}


  {step === 3 && (
    <div
      style={{ overflow: "hidden" }}
      className="container-fluid d-flex justify-content-center align-items-center min-vh-100 login-main"
    >
      <div
        style={{ height: "100vh" }}
        className="row w-100 login-mobile-view-hide"
      >
        <div className="col-7 login-main-left d-flex justify-content-center align-items-center">
          <div>
            <div className="login-left-top container-fluid">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div className="left-img-container text-start px-4">
              <img className="img-fluid" src={left} />
            </div>
            <div className="login-left-circle">
              <img className="img-fluid" src={eclipse_85} />
            </div>
            <div className="w-100 text-right">
              <div className="login-left-bottom">
                <img src={eclipse_bottom} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ boxShadow: "-5px 5px 10px rgba(0, 0, 0, 0.2)" }}
          className="col-lg-5 col-md-5  d-flex align-items-center justify-content-center"
        >
          <div className=" w-100 col-5 login-main-right">
            <div
              style={{ padding: "0px 54px 74px 54px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Create Password
              </h2>
              <form className="w-100 mt-3" onSubmit={handleCreatePassword}>
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">New Password</label>
                  <input
                    type="password"
                    style={{ paddingLeft: "36px" }}
                    className="form-control"
                    id="username"
                    placeholder="Password"
                    value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">Confirm New Password</label>
                  <input
                    style={{ paddingLeft: "36px" }}
                    type="password"
                    className="form-control"
                    id="username"
                    placeholder="Password"
                    value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <div>
                  <button type="submit" className="btn btn-primary">
                    Log In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* mobile view  */}
      <div
        style={{ overflow: "hidden" }}
        className="row w-100 login-mobile-view-show"
      >
        <div className="col-12 login-main-right d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column align-items-center">
            <div className="login-right-top container-fluid text-end">
              <img className="img-fluid" src={eclipse_top} />
            </div>
            <div
              style={{ padding: "0px 23px 36px px", position: "relative" }}
              className=" login-main-right-inner-content d-flex flex-column justify-content-center align-items-start"
            >
              <img
                style={{
                  position: "absolute",
                  top: "-60px",
                  left: "0%",
                  width: "247px",
                  backgroundColor: "white",
                }}
                src={logo}
                alt="Logo"
                className="logo img-fluid mb-5"
              />
              <h2 className="" style={{ marginTop: "90px" }}>
                Create Password
              </h2>
              <form className="w-100 mt-3">
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">New Password</label>
                  <input
                    type="text"
                    style={{ paddingLeft: "36px" }}
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <div
                  style={{ position: "relative" }}
                  className="form-group text-start"
                >
                  <label htmlFor="username">Confirm New Password</label>
                  <input
                    style={{ paddingLeft: "36px" }}
                    type="text"
                    className="form-control"
                    id="username"
                    placeholder="Password"
                  />
                  <LockOpenIcon
                    style={{
                      position: "absolute",
                      top: "32px",
                      fontSize: "23px",
                      left: "10px",
                      color: "#6a6a6a",
                    }}
                    sx={{
                      minWidth: 0,
                      mr: "auto",
                      justifyContent: "center",
                    }}
                  ></LockOpenIcon>
                </div>
                <Link to="/orderList">
                  <button type="submit" className="btn btn-primary">
                    Log In
                  </button>
                </Link>
              </form>
            </div>
          </div>
          <div className="login-right-circle">
            <img className="img-fluid" src={eclipse_85} />
          </div>
          <div className="login-right-bottom"></div>
        </div>
      </div>
    </div>
  )}
    </>
  );
};

export default Login;
